<template>
  <div class="app-container">
    <el-row class="page-buttons">
      <editor-button action="cancel" style="float:right" @click="close" />
    </el-row>
    <pagination
      v-if="numberOfItems > 0"
      :total="numberOfItems"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
    <div ref="tableContainer">
      <el-table
        v-loading="loading"
        :data="items"
        border
        fit
        highlight-current-row
        style="width: 100%"
        :max-height="getMaxTableHeight()"
      >
        <el-table-column :label="$t('accesslog.accessedAt')" width="250">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.accessedAt" type="datetime" :format="dateFormat" readonly />
          </template>
        </el-table-column>

        <el-table-column :label="$t('accesslog.accessedBy')" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.accessedBy }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('accesslog.accessedResource')" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.accessedResource }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('accesslog.ip')" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.ip }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('accesslog.parameters')" width="700">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.parameters" placement="bottom" effect="dark">
              <span
                ><pre>{{ scope.row.parameters }}</pre></span
              >
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import EditorButton from '@/components/crud/EditorButton';
import { closeCurrentTag } from '@/utils/tags';

export default {
  name: 'AccessLogList',
  components: { Pagination, EditorButton },
  data() {
    return {
      listQuery: {
        limit: 50,
        page: 1
      }
    };
  },
  computed: {
    dateFormat() {
      return this.$store.getters.dateTimeFormat;
    },
    items() {
      return this.$store.getters['accesslog/loadedItems'];
    },
    loading() {
      return this.$store.getters['accesslog/isLoading'];
    },
    numberOfItems() {
      return this.$store.getters['accesslog/totalItemsCount'];
    }
  },
  created() {
    this.getList();
  },
  methods: {
    deleteConfirm(id) {
      this.$store
        .dispatch('notify/deleteConfirm')
        .then(() => {
          this.$store.dispatch('accesslog/deleteItem', { id: id }).then(() => {
            this.$store.dispatch('notify/deleteCompleted');
          });
        })
        .catch(() => {
          this.$store.dispatch('notify/deleteCancelled');
        });
    },
    getList(pageInfo) {
      this.$store
        .dispatch('accesslog/replaceItems', {
          query: { limit: this.listQuery.limit, page: this.listQuery.page }
        })
        .then(() => {
          if (pageInfo) {
            this.listQuery.page = pageInfo.page;
          }
        });
    },
    close() {
      closeCurrentTag(this);
    },
    getMaxTableHeight() {
      if (this.$refs.tableContainer) {
        return window.innerHeight - this.$refs.tableContainer.getBoundingClientRect().top - 40;
      }
    }
  }
};
</script>

<style scoped>
.page-buttons {
  margin-bottom: 1em;
}
.edit-input {
  padding-right: 100px;
}

.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
</style>
